import { styled, css } from 'next-yak'

import * as button from './button'
import * as breakpoints from '../constants/breakpoints'
import * as colors from '../constants/colors'
import * as copy from './copy'
import * as glyphs from '../icons/glyphs/index'

export const Count = styled(copy.S.regular)`
  display: none;
  color: ${colors.TEXT_SECONDARY};
  padding: 0 16px;
`

export const Button = styled.button`
  ${button.unstyledButtonCss};

  text-decoration: none;

  width: 32px;
  height: 32px;
  text-align: center;
  padding: 0px;
  align-items: center;
  background-color: ${colors.PRIMARY_GREY_000};
  border-radius: 4px;
  box-sizing: border-box;
  justify-content: center;
  margin-right: 8px;
  position: flex;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  ${copy.Base} {
    line-height: 32px;
    margin-top: -4px;
  }

  ${copy.L.light} {
    color: ${colors.TEXT_TERTIARY};
  }

  &:hover {
    background-color: ${colors.PRIMARY_BLUE_500};

    ${copy.L.light} {
      color: ${colors.PRIMARY_GREY_000};
    }
  }
`

type PaginationItemProps = {
  selected?: boolean
}
export const Item = styled.li<PaginationItemProps>`
  display: inline-block;
  list-style: none;
  max-height: 26px;

  ${({ selected }) => {
    if (selected) {
      return css`
        ${Button} {
          background-color: ${colors.PRIMARY_BLUE_500};

          ${copy.L.light} {
            color: ${colors.PRIMARY_GREY_000};
          }
        }
      `
    }
  }}
`

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  ${glyphs.stroke.CaretDown} {
    color: ${colors.TEXT_TERTIARY};
    margin-right: 8px;
    transform: rotate(90deg);
  }

  ${glyphs.stroke.CaretUp} {
    color: ${colors.TEXT_TERTIARY};
    transform: rotate(90deg);
  }

  ol {
    padding: 0;
  }
`

type ArrowProps = { $disabled: boolean }

export const Arrow = styled(button.UnstyledButton)<ArrowProps>`
  @media not screen and ${breakpoints.TABLET} {
    align-items: center;
    background-color: ${colors.PRIMARY_GREY_000};
    border-radius: 4px;
    box-sizing: border-box;
    height: 32px;
    width: 32px;
    justify-content: center;
    padding: 0px 10px;
    position: flex;
    transition:
      background-color 0.3s ease,
      color 0.3s ease;
    margin-top: 5px;

    ${glyphs.stroke.CaretDown} {
      margin-top: -6px;
      margin-left: -2px;
    }

    ${glyphs.stroke.CaretUp} {
      margin-top: -6px;
    }

    &:hover {
      background-color: ${colors.PRIMARY_BLUE_500};

      ${glyphs.stroke.CaretDown}, ${glyphs.stroke.CaretUp} {
        color: ${colors.PRIMARY_GREY_000};
      }
    }
  }

  ${({ $disabled }) => {
    if ($disabled) {
      return css`
        cursor: not-allowed;

        ${glyphs.stroke.CaretDown} {
          color: ${colors.PRIMARY_GREY_500};
        }

        ${glyphs.stroke.CaretUp} {
          color: ${colors.PRIMARY_GREY_500};
        }
      `
    }
  }}
`

export const EllipsisItem = styled(Item)<Omit<PaginationItemProps, 'selected'>>`
  pointer-events: none;
  margin-right: 8px;

  &::after {
    content: '…';
    ${copy.styles.L.light};
    color: ${colors.TEXT_TERTIARY};
  }
`
